import { render, staticRenderFns } from "./QuotaTable.vue?vue&type=template&id=d8602d1a&scoped=true&"
import script from "./QuotaTable.vue?vue&type=script&lang=js&"
export * from "./QuotaTable.vue?vue&type=script&lang=js&"
import style0 from "./QuotaTable.vue?vue&type=style&index=0&id=d8602d1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8602d1a",
  null
  
)

export default component.exports